import { loginState } from '../state/loginState'
import { FETCH_LOGIN_REQUEST, FETCH_LOGIN_SUCCESS, LOGOUT_USER_REQUEST,
            FETCH_LOGIN_ERROR,LOGIN_VIEW_REQUEST
         } from '../actions/loginAction'

var initialStatusCode='';
export function loginReducer(state = loginState, action) {
    switch (action.type) {
        case FETCH_LOGIN_REQUEST:
            
            return Object.assign({}, state, {
                userName: action.userName,
                isLoading: action.isLoading,
                password: action.password,
                statusCode: initialStatusCode
            })
        case LOGIN_VIEW_REQUEST:
            
            return Object.assign({}, state, {
                statusCode: initialStatusCode,
                errorMessage: action.errorMessage
            })    
        case FETCH_LOGIN_SUCCESS:
            return Object.assign({}, state, {
                userName: action.userName,
                isLoading: action.isLoading,
                password: action.password,
                Message: action.Message,
                statusCode: action.loginStatus,
                authTokenId: action.authTokenId,
                userId: action.userId
            })
        case FETCH_LOGIN_ERROR:
            
            return Object.assign({}, state, {
                isLoading:false,
                statusCode: action.statusCode,
                errorCode: action.errorCode,
                errorMessage: action.errorMessage,
                

            })
        case LOGOUT_USER_REQUEST:
            return Object.assign({}, state, {
                userName: action.userName,
                isLoading: action.isLoading,
                password: action.password,
                Message: action.Message,
                loginStatus: action.loginStatus,
                authTokenId: action.authTokenId,
                userId: action.userId
            })
        default:
            return state;
    }
} 
